import styled from 'styled-components';

export const StylesNotFound = styled.div`
  min-height: calc(100vh - 176px);
  max-width: 1280px;
`;
